import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgMijnWoning = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <mask
      id="Mijn_woning_svg__a"
      width={22}
      height={26}
      x={9}
      y={7}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <path
        fill="#fff"
        d="M20 7 9 15v18h4V21h7v12h11V15z"
      />
    </mask>
    <g mask="url(#Mijn_woning_svg__a)">
      <path
        fill="#F29FC5"
        d="m-4.5 5.855 12.25 7.07L14.825.675zM7.75 12.925.675 25.175 20 20z"
      />
      <path
        fill="#F8C9E9"
        d="m5.855 44.5 7.07-12.25-12.25-7.075z"
      />
      <path
        fill="#F29FC5"
        d="m25.175 39.325 7.075-12.25L20 20z"
      />
      <path
        fill="#F8C9E9"
        d="m20 20-7.075 12.25 12.25 7.075z"
      />
      <path
        fill="#F29FC5"
        d="M34.145-4.5 14.825.675 27.07 7.75z"
      />
      <path
        fill="#F8C9E9"
        d="M39.325 14.825 27.07 7.75 20 20zM5.855 44.5l19.32-5.175-12.25-7.075z"
      />
      <path
        fill="#F29FC5"
        d="m.675 25.175 12.25 7.075L20 20zM20 20l12.25 7.075 7.075-12.25zM44.5 34.145l-12.25-7.07-7.075 12.25zM20 20l7.07-12.25L14.825.675z"
      />
      <path
        fill="#F8C9E9"
        d="M14.825.675 7.75 12.925 20 20z"
      />
      <path
        fill="#F29FC5"
        d="M34.145-4.5 27.07 7.75l12.255 7.075z"
      />
    </g>
    <path
      fill="#fff"
      d="M20 21h-7v12h7z"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgMijnWoning);

export default ForwardRef;
